import React, { useEffect, useState } from 'react';
import HeaderSCI from './HeaderSCI';
// import HeaderSCI from '../ControlInterno/HeaderSCI';
import './armonizacionContable.css';

const principios = [
  
   {
    id:8,
    color: '#a98188',
    title: "Ejercicio fiscal 2026",
     items: [

      
       {
        label: "Programación de Presupuesto Anual  5 al Millar",
        subitems: [
          {
            label: "•	Programación de Presupuesto Anual 5 al Millar",
              url: "https://s-contraloria.hidalgo.gob.mx/descargables/2026/presupuestoanual/Presupuesto Anual 2026.pdf",
          },
     
        ]
        },


       {
        label: "*Informes Mensuales*",
        
        
        subitems: [
          {
            label: "Enero",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/2026/mensuales/Enero.pdf",
          },
          {
            label: "Febrero",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/2026/mensuales/Febrero.pdf",
          },
          {
            label: "Marzo",
             url: "https://s-contraloria.hidalgo.gob.mx/descargables/2026/mensuales/Marzo.pdf",
          },
          {
            label: "Abril",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/2026/mensuales/Abril.pdf",
          },
          {
            label: "Mayo",
             url: "https://s-contraloria.hidalgo.gob.mx/descargables/2026/mensuales/Mayo.pdf",
          },
          {
            label: "Junio",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/2026/mensuales/Junio.pdf"
          },
          // {
          //   label: "Julio",
          //   url: "/micro/principio1/codigo_etica_2025.pdf"
          // },
          // {
          //   label: "Agosto",
          //   url: "/micro/principio1/codigo_etica_2025.pdf"
          // },
          // {
          //   label: "Septiembre",
          //   url: "/micro/principio1/codigo_etica_2025.pdf"
          // },
          // {
          //   label: "Octubre",
          //   url: "/micro/principio1/codigo_etica_2025.pdf"
          // },

          // {
          //   label: "Noviembre",
          //   url: "/micro/principio1/codigo_etica_2026.pdf"
          // },
          // {
          //   label: "Diciembre",
          //   url: "/micro/principio1/anexos_codigo_etica.pdf"
          // }
        ]
      },
       {
        label: "*Informes Acumulados*",
        subitems: [
          // {
          //   label: "Enero",
          //   url: "/micro/principio1/codigo_etica_2025.pdf"
          // },
          {
            label: "Febrero",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/2026/acumulados/Febrero.pdf",
          },
          {
            label: "Marzo",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/2026/acumulados/Marzo.pdf",
          },
          {
            label: "Abril",
             url: "https://s-contraloria.hidalgo.gob.mx/descargables/2026/acumulados/Abril.pdf",
          },
          {
            label: "Mayo",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/2026/acumulados/Mayo.pdf",
          },
          {
            label: "Junio",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/2026/acumulados/Junio.pdf",
          },
          // {
          //   label: "Julio",
          //   url: "/micro/principio1/codigo_etica_2025.pdf"
          // },
          // {
          //   label: "Agosto",
          //   url: "/micro/principio1/codigo_etica_2025.pdf"
          // },
          // {
          //   label: "Septiembre",
          //   url: "/micro/principio1/codigo_etica_2025.pdf"
          // },
          // {
          //   label: "Octubre",
          //   url: "/micro/principio1/codigo_etica_2025.pdf"
          // },

          // {
          //   label: "Noviembre",
          //   url: "/micro/principio1/codigo_etica_2026.pdf"
          // },
          // {
          //   label: "Diciembre",
          //   url: "/micro/principio1/anexos_codigo_etica.pdf"
          // }
        ]
      },
     
      //   {
      //   label: "INFORME DE CIERRE ANUAL 2026",
      //   subitems: [
      //     {
      //       label: "•	INFORME CIERRE ANUAL 2026",
      //       url: "https://s-contraloria.hidalgo.gob.mx/descargables/2026/trimestrales/1er. Informe Trimestral.pdf",
      //     },
          
          
      //   ]
      // },


    
      {
        label: "Conciliaciones Mensuales con la Secretaría de Hacienda",
        subitems: [
          {
            label: "Enero",
             url: "https://s-contraloria.hidalgo.gob.mx/descargables/2026/conciliaciones/Enero .pdf",
          },
          {
            label: "Febrero",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/2026/conciliaciones/Febrero.pdf",
          },
          {
            label: "Marzo",
             url: "https://s-contraloria.hidalgo.gob.mx/descargables/2026/conciliaciones/Marzo .pdf",
          },
          {
            label: "Abril",
             url: "https://s-contraloria.hidalgo.gob.mx/descargables/2026/conciliaciones/Abril .pdf",
          },
          {
            label: "Mayo",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/2026/conciliaciones/Mayo.pdf",
          },
          {
            label: "Junio",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/2026/conciliaciones/Junio.pdf"
          },
          // {
          //   label: "Julio",
          //   url: "/micro/principio1/codigo_etica_2025.pdf"
          // },
          // {
          //   label: "Agosto",
          //   url: "/micro/principio1/codigo_etica_2025.pdf"
          // },
          // {
          //   label: "Septiembre",
          //   url: "/micro/principio1/codigo_etica_2025.pdf"
          // },
          // {
          //   label: "Octubre",
          //   url: "/micro/principio1/codigo_etica_2025.pdf"
          // },

          // {
          //   label: "Noviembre",
          //   url: "/micro/principio1/codigo_etica_2026.pdf"
          // },
          // {
          //   label: "Diciembre",
          //   url: "/micro/principio1/anexos_codigo_etica.pdf"
          // }
        ]
      },
       {
        label: "Conciliaciones Trimestrales con la Secretaría de Hacienda",
        subitems: [
          {
            label: "1er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/2026/conciliacionesTrimestrales/1er. Informe Trimestral.pdf",
          },
          {
            label: "2do. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/2026/conciliacionesTrimestrales/2do. Informe Trimestral.pdf",
          },
          // {
          //   label: "3er. Informe Trimestral",
          //   url: "/micro/principio1/codigo_etica_2025.pdf"
          // },
          // {
          //   label: "4to. Informe Trimestral",
          //   url: "/micro/principio1/codigo_etica_2025.pdf"
          // },
        
          
        ]
      },
      
         {
        label: "1 al Millar",
        subitems: [
          {
            label: "1er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/2026/millar/1er. Informe Trimestral.pdf",
          },
         {
            label: "2do. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/2026/millar/1er. Informe Trimestral.pdf",
          },
          // {
          //   label: "3er. Informe Trimestral",
          //   url: "/micro/principio1/codigo_etica_2025.pdf"
          // },
          // {
          //   label: "4to. Informe Trimestral",
          //   url: "/micro/principio1/codigo_etica_2025.pdf"
          // },
          // {
          //   label: "INFORME ANUAL 1 AL MILLAR 2025",
          //   url: "/micro/principio1/codigo_etica_2025.pdf"
          // },
          
        ]
      },
     
    ]
  },

  
  
  
  {
    id: 1,
    color: '#621132',
    title: "Ejercicio fiscal 2025.",
    items: [

       {
        label: "Programación de Presupuesto Anual Presupuesto 5 al Millar",
        subitems: [
          // {
          //   label: "Presupuesto Anual 2021",
          //   url: "https://s-contraloria.hidalgo.gob.mx/descargables/PRESUPUESTO_5ALMILLAR_2021.pdf"
          // },
         
        ]
        },


       {
        label: "*Informes Mensuales*",
         subitems: [
          {
            label: "Enero",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Enero2025mensual.pdf"
          },
          {
            label: "Febrero",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Febrero2025mensual.pdf"
          },
          {
            label: "Marzo",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Marzo2025mensual.pdf"
          },
          {
            label: "Abril",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Abril2025mensual.pdf"
          },
          {
            label: "Mayo",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Mayo2025mensual.pdf"
          },
          {
            label: "Junio",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Junio2025mensual.pdf"
          },
          {
            label: "Julio",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Julio2025mensual.pdf"
          },
          {
            label: "Agosto",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Agosto2025mensual.pdf"
          },
          {
            label: "Septiembre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Septiembre2025mensual.pdf"
          },
          {
            label: "Octubre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Octubre2025mensual.pdf"
          },

          {
            label: "Noviembre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Noviembre2025mensual.pdf"
          },
          {
            label: "Diciembre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Diciembre2025mensual.pdf"
          }
        ]
      },
       {
        label: "*Informes Acumulados*",
        subitems: [
          {
            label: "Enero",
            url: ""
          },
          {
            label: "Febrero",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Febrero2025acumulado.pdf"
          },
          {
            label: "Marzo",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Marzo2025acumulado.pdf"
          },
          {
            label: "Abril",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Abril2025acumulado.pdf"
          },
          {
            label: "Mayo",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Mayo2025acumulado.pdf"
          },
          {
            label: "Junio",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Junio2025acumulado.pdf"
          },
          {
            label: "Julio",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Julioa2025.pdf"
          },
          {
            label: "Agosto",
          url: "https://s-contraloria.hidalgo.gob.mx/descargables/Agostoa2025.pdf"
          },
          {
            label: "Septiembre",
          url: "https://s-contraloria.hidalgo.gob.mx/descargables/Septiembrea2025.pdf"
          },
          {
            label: "Octubre",
                url: "https://s-contraloria.hidalgo.gob.mx/descargables/Octubrea2025.pdf"
          },

          {
            label: "Noviembre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Noviembrea2025.pdf"
          },
          {
            label: "Diciembre",
             url: "https://s-contraloria.hidalgo.gob.mx/descargables/Diciembrea2025.pdf"
          }
        ]
      },

         {
        label: "INFORME DE CIERRE ANUAL 2025 ",
        subitems: [
          {
            label: "INFORME CIERRE ANUAL 2025",
            // url: "https://s-contraloria.hidalgo.gob.mx/descargables/PRESUPUESTO_5ALMILLAR_2021.pdf"
          },
         
        ]
        },
    
      {
        label: "Conciliaciones mesuales con la Secretaría de Hacienda",
        subitems: [
          {
            label: "Enero",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Eneroconciliacion2025.pdf"
          },
          {
            label: "Febrero",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Febreroconciliacion2025.pdf"
          },
          {
            label: "Marzo",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Marzoconciliacion2025.pdf"
          },
          {
            label: "Abril",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Abrilconciliacion2025.pdf"
          },
          {
            label: "Mayo",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Mayoconciliacion2025.pdf"
          },
          {
            label: "Junio",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Juniocon2025.pdf"
          },
          {
            label: "Julio",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Juliocon2025.pdf"
          },
          {
            label: "Agosto",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Agostocon2025.pdff"
          },
          {
            label: "Septiembre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Septiembrecon2025.pdf"
          },
          {
            label: "Octubre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Octubrecon2025.pdf"
          },

          {
            label: "Noviembre",
            url: "/micro/principio1/codigo_etica_2026.pdf"
          },
          {
            label: "Diciembre",
            url: "/micro/principio1/anexos_codigo_etica.pdf"
          }
        ]
      },
       {
        label: "Conciliaciones Trimestrales con la Secretaría de Hacienda",
        subitems: [
          {
            label: "1er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/1%C2%BA%20Trimestre%20Anexo%2011Aconciliacion2025.pdf"
          },
          {
            label: "2do. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/2%C2%BA%20Trimestre%20Anexo%2011A.pdf"
          },
          {
            label: "3er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/3%C2%BA%20Trimestre%20Anexo%2011A.pdf"
          },
          {
            label: "4to. Informe Trimestral",
            url: "/micro/principio1/codigo_etica_2025.pdf"
          },
        
             {
        label: "1 al Millar",
        subitems: [
          {
            label: "1er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/1er_Informe_Trimestral_2025.pdf"
          },
          {
            label: "2do. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/2do_Informe_Trimestral_2025_M.pdf"
          },
          {
            label: "3er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/3er_Informe_Trimestral_2025.pdf"
          },
          {
            label: "4to. Informe Trimestral",
            url: ""
          },
          {
            label: "INFORME ANUAL 1 AL MILLAR 2025",
            url: ""
          },
          
        ]
      },
        ]
      },
      
     
    ]
  },
  {
    id: 2,
    color: '#9e2348',
    title: "Ejercicio fiscal 2024.",
     items: [

       {
        label: "Programación de Presupuesto Anual 5 al Millar",
        
        
        subitems: [
          {
            label: "Enero",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_5ALMILLAR_ENERO_2024.pdf"
          },
          {
            label: "Febrero",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_FEBRERO_2024.pdf"
          },
          {
            label: "Marzo",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_5ALMILLAR_MARZO_2024.pdf"
          },
          {
            label: "Abril",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_5ALMILLAR_ABRIL_2024.pdf"
          },
          {
            label: "Mayo",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_5ALMILLAR_MAYO_2024.pdf"
          },
          {
            label: "Junio",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Informe_de_Ingresos_y_Egresos_Mensual_junio_2024.pdf"
          },
          {
            label: "Julio",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Informe_de_Ingresos_y_Egresos_Mensual_julio_2024.pdf"
          },
          {
            label: "Agosto",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Informe_de_Ingresos_y_Egresos_Mensual_agosto_2024.pdf"
          },
          {
            label: "Septiembre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Informe_de_Ingresos_y%20_Egresos_Mensual_septiembre_2024.pdf"
          },
          {
            label: "Octubre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Informe_de_Ingresos_y_Egresos_Mensual_octubre_2024.pdf"
          },

          {
            label: "Noviembre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Informe_Mensual_noviembre_2024.pdf"
          },
          {
            label: "Diciembre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Informe_Mensual_diciembre_2024.pdf"
          },
           {
            label: "INFORME CIERRE ANUAL 2024",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Informe_de_Cierre_Anual_2024_5MF.pdf"
          }

          
        ]
      },
       {
        label: "Informes Acumulados",
        subitems: [
          {
            label: "Enero",
            url: "/micro/principio1/codigo_etica_2025pdf"
          },
          {
            label: "Febrero",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ACUMULADO_FEBRERO_5ALMILAR_2024.pdf"
          },
          {
            label: "Marzo",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ACUMULADO_MARZO_5ALMILAR_2024.pdf"
          },
          {
            label: "Abril",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ACUMULADO_ABRIL_5ALMILAR_2024.pdf"
          },
          {
            label: "Mayo",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ACUMULADO_MAYO_5ALMILAR_2024.pdf"
          },
          {
            label: "Junio",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Informe_de_Ingresos_y_Egresos_Acumulado_junio_2024.pdf"
          },
          {
            label: "Julio",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Informe_de_Ingresos_y%20Egresos_Acumulado_julio_2024.pdf"
          },
          {
            label: "Agosto",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Informe_de_Ingresos_y_Egresos_Acumulado_agosto_2024.pdf"
          },
          {
            label: "Septiembre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Informe_de_Ingresos_y_Egresos_Acumulado_septiembre_2024.pdf"
          },
          {
            label: "Octubre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Informe_de_Ingresos_y_Egresos_Acumulado_octubre_2024.pdf"
          },

          {
            label: "Noviembre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Informe_Acumulado_noviembre_2024.pdf"
          },
          {
            label: "Diciembre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Informe_Acumulado_diciembre_2024.pdf"
          }
        ]
      },
    
      {
        label: "Conciliaciones mensuales con la Secretaría de Hacienda",
        subitems: [
          {
            label: "Enero",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_MENSUAL_ENERO_FEDERAL_2024.pdf"
          },
          {
            label: "Febrero",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_MENSUAL_FEDERAL_FEBRERO_2024.pdf"
          },
          {
            label: "Marzo",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_MARZO_FEDERAL_2024.pdf"
          },
          {
            label: "Abril",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_ABRIL_FEDERAL_2024.pdf"
          },
          {
            label: "Mayo",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_MAYO_FEDERAL_2024.pdf"
          },
          {
            label: "Junio",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Conciliaci%C3%B3n_con_la_Secretar%C3%ADa_de_Hacienda_junio_2024.pdf"
          },
          {
            label: "Julio",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Conciliaci%C3%B3n_con_la_Secretar%C3%ADa_de_Hacienda_julio_2024.pdf"
          },
          {
            label: "Agosto",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Conciliaci%C3%B3n_con_la_Secretar%C3%ADa_de_Hacienda_agosto_2024.pdf"
          },
          {
            label: "Septiembre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Conciliaci%C3%B3n_con_la_Secretar%C3%ADa_de_Hacienda_septiembre_2024.pdf"
          },
          {
            label: "Octubre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Conciliaci%C3%B3n_con_la_Secretar%C3%ADa_de_Hacienda_octubre_2024.pdf"
          },

          {
            label: "Noviembre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Conciliaci%C3%B3n_con_la_Secretar%C3%ADa_de_Hacienda_noviembre_2024.pdf"
          },
          {
            label: "Diciembre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Conciliaci%C3%B3n_con_la_Secretar%C3%ADa_de_Hacienda_diciembre_2024.pdf"
          }
        ]
      },
       {
        label: "Conciliaciones Trimestrales con la Secretaría de Hacienda",
        subitems: [
          {
            label: "1er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_1ER_TRIMESTRE_FEDERAL_2024.pdf"
          },
          {
            label: "2do. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Conciliaciones_con_la_Secretar%C3%ADa_de_Hacienda_2do._Informe_Trimestral_2024.pdf"
          },
          {
            label: "3er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Conciliaciones_con_la_Secretar%C3%ADa_de_Hacienda_3er._Informe_Trimestral_2024.pdf"
          },
          {
            label: "4to. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Conciliaciones_con_la_Secretar%C3%ADa_de_Hacienda_4to._Informe_Trimestral_2024.pdf"
          },
        
          
        ]
      },
         {
        label: "1 al Millar",
        subitems: [
          {
            label: "1er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_1ER_TRIMESTRE_1ALMILLAR_2024.pdf"
          },
          {
            label: "2do. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Informe_de_Ingresos_y_Egresos_2do._Trimestre_1_al_Millar.pdf"
          },
          {
            label: "3er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Informe_de_Ingresos_y_Egresos_3er._Trimestre_1_al_Millar.pdf"
          },
          {
            label: "4to. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/4to._Informe_Trimestral.pdf"
          },
          {
            label: "INFORME ANUAL 1 AL MILLAR 2025",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Informe_Anual_1_al_Millar_2024.pdf"
          },
          
        ]
      },
      
     
    ]
  },
  {
    id: 3,
    color: '#a98188',
    title: "Ejercicio fiscal 2023.",
     items: [


       {
        label: "Programación de Presupuesto Anual  5 al Millar",
        subitems: [
          {
            label: "Programación de Presupuesto Anual  5 al Millar",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/PRESUPUESTO_5ALMILLAR_2023.pdf"
          },
         
        ]
        },

       {
        label: "Informes Mensuales",
          subitems: [
         
          {
            label: "Enero",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_5ALMILLAR_ENERO_2023.pdf"
          },
          {
            label: "Febrero",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_5ALMILLAR_FEBRERO_2023.pdf"
          },
          {
            label: "Marzo",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_5ALMILLAR_MARZO_2023.pdf"
          },
          {
            label: "Abril",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_5ALMILLAR_ABRIL_2023.pdf"
          },
          {
            label: "Mayo",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_5ALMILLAR_MAYO_2023.pdf"
          },
          {
            label: "Junio",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_5ALMILLAR_JUNIO_2023.pdf"
          },
          {
            label: "Julio",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_5ALMILLAR_JULIO_2023.pdf"
          },
          {
            label: "Agosto",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_5ALMILLAR_AGOSTO_2023.pdf"
          },
          {
            label: "Septiembre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_5ALMILLAR_SEPTIEMBRE_2023.pdf"
          },
          {
            label: "Octubre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_5ALMILLAR_OCTUBRE_2023.pdf"
          },

          {
            label: "Noviembre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_5ALMILLAR_NOVIEMBRE_2023.pdf"
          },
          {
            label: "Diciembre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_5ALMILLAR_DICIEMBRE_2023.pdf"
          },
          {
            label: "INFORME CIERRE ANUAL 2023",
            url: "  https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_CIERRE_ANUAL_2023.pdf"
          },
        ]
      },
       {
        label: "Informes Acumulados",
        subitems: [
       

          // {
          //   label: "Enero",
          //   url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ACUMULADO_FEBRERO_5ALMILAR_2023.pdf"
          // },
          {
            label: "Febrero",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ACUMULADO_FEBRERO_5ALMILAR_2023.pdf"
          },
          {
            label: "Marzo",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ACUMULADO_MARZO_5ALMILAR_2023.pdf"
          },
          {
            label: "Abril",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ACUMULADO_ABRIL_5ALMILAR_2023.pdf"
          },
          {
            label: "Mayo",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ACUMULADO_MAYO_5ALMILAR_2023.pdf"
          },
          {
            label: "Junio",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ACUMULADO_JUNIO_5ALMILAR_2023.pdf"
          },
          {
            label: "Julio",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ACUMULADO_JULIO_5ALMILAR_2023.pdf"
          },
          {
            label: "Agosto",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ACUMULADO_AGOSTO_5ALMILAR_2023.pdf"
          },
          {
            label: "Septiembre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ACUMULADO_SEPTIEMBRE_5ALMILAR_2023.pdf"
          },
          {
            label: "Octubre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ACUMULADO_OCTUBRE_5ALMILAR_2023.pdf"
          },

          {
            label: "Noviembre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ACUMULADO_NOVIEMBRE_5ALMILAR_2023.pdf"
          },
          {
            label: "Diciembre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ACUMULADO_DICIEMBRE_5ALMILAR_2023.pdf"
          }
        ]
      },
     
      {
        label: "Conciliaciones mensuales con la Secretaría de Hacienda",
        subitems: [
          {
            label: "Enero",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_ENERO_FEDERAL_2023.pdf"
          },
          {
            label: "Febrero",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_FEBRERO_FEDERAL_2023.pdf"
          },
          {
            label: "Marzo",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_MARZO_FEDERAL_2023.pdf"
          },
          {
            label: "Abril",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_ABRIL_FEDERAL_2023.pdf"
          },
          {
            label: "Mayo",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_MAYO_FEDERAL_2023.pdf"
          },
          {
            label: "Junio",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_JUNIO_FEDERAL_2023.pdf"
          },
          {
            label: "Julio",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_JULIO_FEDERAL_2023.pdf"
          },
          {
            label: "Agosto",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_AGOSTO_FEDERAL_2023.pdf"
          },
          {
            label: "Septiembre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_SEPTIEMBRE_FEDERAL_2023.pdf"
          },
          {
            label: "Octubre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_OCTUBRE_FEDERAL_2023.pdf"
          },

          {
            label: "Noviembre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_NOVIEMBRE_FEDERAL_2023.pdf"
          },
          {
            label: "Diciembre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_DICIEMBRE_FEDERAL_2023.pdf"
          }
        ]
      },
       {
        label: "Conciliaciones Trimestrales con la Secretaría de Hacienda",
        subitems: [
          {
            label: "1er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_1ER_TRIMESTRE_FEDERAL_2023.pdf"
          },
          {
            label: "2do. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_2DO_TRIMESTRE_FEDERAL_2023.pdf"
          },
          {
            label: "3er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_3ER_TRIMESTRE_FEDERAL_2023.pdf"
          },
          {
            label: "4to. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_4TO_TRIMESTRE_FEDERAL_2023.pdf"
          },
        
          
        ]
      },
      
       {
        label: "1 al Millar",
        subitems: [
          {
            label: "1er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_1ER_TRIMESTRE_1ALMILLAR_2023.pdf"
          },
          {
            label: "2do. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_2DO_TRIMESTRE_1ALMILLAR_2023.pdf"
          },
          {
            label: "3er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_3ER_TRIMESTRE_1ALMILLAR_2023.pdf"
          },
          {
            label: "4to. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_4TO_TRIMESTRE_1ALMILLAR_2023.pdf"
          },
          {
            label: "INFORME ANUAL 1 AL MILLAR 2025",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ANUAL_1ALMILLAR_2023.pdf"
          },
          
        ]
      },
    ]
  },
  {
    id:4,
    color: '#a98188',
    title: "Ejercicio fiscal 2022.",
     items: [

        {
        label: "Programación de Presupuesto Anual 5 al Millar",
        subitems: [
          {
            label: "Programación de Presupuesto Anual 5 al Millar",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/PRESUPUESTO_5ALMILLAR_2022.pdf"
          },
         
        ]
        },

        {
        label: "Informes Mensuales",
        
        
        subitems: [
          {
            label: "Enero",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_5ALMILLAR_ENERO_2022.pdf"
          },
          {
            label: "Febrero",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_5ALMILLAR_FEBRERO_2022.pdf"
          },
          {
            label: "Marzo",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_MARZO_5ALMILLAR_2022.pdf"
          },
          {
            label: "Abril",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_ABRIL_5ALMILLAR_2022.pdf"
          },
          {
            label: "Mayo",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_MAYO_5ALMILLAR_2022.pdf"
          },
          {
            label: "Junio",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_JUNIO_2022.pdf"
          },
          {
            label: "Julio",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_JULIO_2022.pdf"
          },
          {
            label: "Agosto",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_AGOSTO_2022.pdf"
          },
          {
            label: "Septiembre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_SEPTIEMBRE_2022.pdf"
          },
          {
            label: "Octubre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_OCTUBRE_2022.pdf"
          },

          {
            label: "Noviembre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_NOVIEMBRE_2022.pdf"
          },
          {
            label: "Diciembre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_DICIEMBRE_2022.pdf"
          },
          {
            label: "Informe Cierre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_CIERRE_ANUAL_2022.pdf"
          }
        ]
      },
       {
        label: "Informes Acumulados",
        subitems: [
          // {
          //   label: "Enero",
          //   url: "/micro/principio1/codigo_etica_2025.pdf"
          // },
          {
            label: "Febrero",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ACUMULADO_FEBRERO_5ALMILAR.pdf"
          },
          {
            label: "Marzo",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ACUMULADO_MARZO_5ALMILLAR_2022.pdf"
          },
          {
            label: "Abril",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ACUMULADO_ABRIL_5ALMILLAR_2022.pdf"
          },
          {
            label: "Mayo",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ACUMULADO_MAYO_5ALMILLAR_2022.pdf"
          },
          {
            label: "Junio",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ACUMULADO_ENERO_JUNIO_2022.pdf"
          },
          {
            label: "Julio",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ACUMULADO_ENERO_JULIO_2022.pdf"
          },
          {
            label: "Agosto",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ACUMULADO_ENERO_AGOSTO_2022.pdf"
          },
          {
            label: "Septiembre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ACUMULADO_ENERO_SEPTIEMBRE_2022.pdf"
          },
          {
            label: "Octubre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ACUMULADO_ENERO_OCTUBRE_2022.pdf"
          },

          {
            label: "Noviembre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ACUMULADO_ENERO_NOVIEMBRE_2022.pdf"
          },
          {
            label: "Diciembre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ACUMULADO_ENERO_DICIEMBRE_2022.pdf"
          }
        ]
      },
     
      {
        label: "Conciliaciones mensuales con la Secretaría de Hacienda",
        subitems: [
          {
            label: "Enero",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_ENERO_FEDERAL_2022.pdf"
          },
          {
            label: "Febrero",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_FEBRERO_FEDERAL_2022.pdf"
          },
          {
            label: "Marzo",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_MARZO_FEDERAL_2022.pdf"
          },
          {
            label: "Abril",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_ABRIL_FEDERAL_2022.pdf"
          },
          {
            label: "Mayo",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_MAYO_FEDERAL_2022.pdf"
          },
          {
            label: "Junio",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_JUNIO_FEDERAL_2022.pdf"
          },
          {
            label: "Julio",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_JULIO_FEDERAL_2022.pdf"
          },
          {
            label: "Agosto",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_AGOSTO_FEDERAL_2022.pdf"
          },
          {
            label: "Septiembre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_SEPTIEMBRE_FEDERAL_2022.pdf"
          },
          {
            label: "Octubre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_OCTUBRE_FEDERAL_2022.pdf"
          },

          {
            label: "Noviembre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_NOVIEMBRE_FEDERAL_2022.pdf"
          },
          {
            label: "Diciembre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_MENSUAL_DICIEMBRE_FEDERAL_2022.pdf"
          }
        ]
      },
       {
        label: "Conciliaciones Trimestrales con la Secretaría de Hacienda",
        subitems: [
          {
            label: "1er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_1ER_TRIMESTRE_FEDERAL_2022.pdf"
          },
          {
            label: "2do. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_2DO_TRIMESTRE_FEDERAL_2022.pdf"
          },
          {
            label: "3er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_3ER_TRIMESTRE_FEDERAL_2022.pdf"
          },
          {
            label: "4to. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_4TO_TRIMESTRE_2022.pdf"
          },
        
          
        ]
      },

        {
        label: "1 al Millar",
        subitems: [
          {
            label: "1er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_1ERTRIMESTRE_1ALMILLAR_2022.pdf"
          },
          {
            label: "2do. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_2DO_TRIMESTRE_1ALMILLAR_2022.pdf"
          },
          {
            label: "3er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_3ERTRIMESTRE_1ALMILLAR_2022.pdf"
          },
          {
            label: "4to. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_4TO_TRIMESTRE_1ALMILLAR_2022.pdf"
          },
          {
            label: "INFORME ANUAL 1 AL MILLAR 2025",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ANUAL_1ALMILLAR_2022.pdf"
          },
          
        ]
      },
      
     
    ]
  },
  {
    id:5,
    color: '#a98188',
    title: "Ejercicio fiscal 2021.",
     items: [
        {
        label: "Programación de Presupuesto Anual  5 al Millar",
        subitems: [
          {
            label: "Programación de Presupuesto Anual  5 al Millar",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/PRESUPUESTO_5ALMILLAR_2021.pdf"
          },
         
        ]
        },

        {
        label: "Informes Mensuales",
              
        
        subitems: [
          {
            label: "Enero",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_INGRESOS_EGRESOS_MENSUAL_ENERO_2021.pdf"
          },
          {
            label: "Febrero",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_INGRESOS_EGRESOS_5_AL_MILLAR_FEBRERO_2021.pdf"
          },
          {
            label: "Marzo",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_INGRESOS_EGRESOS_5_AL_MILLAR_MARZO_2021.pdf"
          },
          {
            label: "Abril",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_ABRIL_5ALMILLAR_2022.pdf"
          },
          {
            label: "Mayo",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_EGRESOS_INGRESOS_MAYO_2021.pdf"
          },
          {
            label: "Junio",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_JUNIO_2021.pdf"
          },
          {
            label: "Julio",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_JULIO_2021.pdf"
          },
          {
            label: "Agosto",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_AGOSTO_2021.pdf"
          },
          {
            label: "Septiembre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_SEPTIEMBRE_2021.pdf"
          },
          {
            label: "Octubre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_OCTUBRE_2021.pdf"
          },

          {
            label: "Noviembre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_NOVIEMBRE_2021.pdf"
          },
          {
            label: "Diciembre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_DICIEMBRE_2021.pdf"
          },
          {
            label: "Informe Cierre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_CIERRE_5ALMILLAR_2021.pdf"
          }
        ]
      },
       {
        label: "Informes Acumulados",
        subitems: [
          // {
          //   label: "Enero",
          //   url: "/micro/principio1/codigo_etica_2025.pdf"
          // },
          {
            label: "Febrero",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ACUMULADO_INGRESOS_EGRESOS_5_AL_MILLAR_FEBRERO_2021.pdf"
          },
          {
            label: "Marzo",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ACUMULADO_INGRESOS_EGRESOS_5_AL_MILLAR_MARZO_2021.pdf"
          },
          {
            label: "Abril",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_ACUMULADO_5ALMILLAR_ABRIL_2021.pdf"
          },
          {
            label: "Mayo",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ACUMULADO_EGRESOS_INGRESOS_MAYO_2021.pdf"
          },
          {
            label: "Junio",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ACUMULADO_INGRESOS_EGRESOS_A_JUNIO_2020_5M.pdf"
          },
          {
            label: "Julio",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ACUMULADO_MES_DE_JULIO_2021.pdf"
          },
          {
            label: "Agosto",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ACUMULADO_AGOSTO_2021.pdff"
          },
          {
            label: "Septiembre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ACUMULADO_SEPTIEMBRE_2021.pdf"
          },
          {
            label: "Octubre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ACUMULADO_OCTUBRE_2021.pdf"
          },

          {
            label: "Noviembre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ACUMULADO_NOVIEMBRE_2021.pdff"
          },
          {
            label: "Diciembre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ACUMULADO_DICIEMBRE_2021.pdf"
          }
        ]
      },
     
      {
        label: "Conciliaciones mensuales con la Secretaría de Hacienda",
        subitems: [
          {
            label: "Enero",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_FINANZAS_ENERO_2021.pdf"
          },
          {
            label: "Febrero",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_FINANZAS_FEBRERO_2021.pdf"
          },
          {
            label: "Marzo",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION%205M%20FEDERAL%20MARZO.pdff"
          },
          {
            label: "Abril",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_5M_FEDERAL_ABRIL_2021.pdf"
          },
          {
            label: "Mayo",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_MAYO_5ALMILLAR_FEDERAL_2021.pdf"
          },
          {
            label: "Junio",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_MENSUAL_JUNIO_2021.pdf"
          },
          {
            label: "Julio",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_CONTABILIDAD_MES_DE_JULIO_2021.pdf"
          },
          {
            label: "Agosto",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_MENSUAL_AGOSTO_2021.pdf"
          },
          {
            label: "Septiembre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_MENSUAL_SEPTIEMBRE_2021.pdf"
          },
          {
            label: "Octubre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_MENSUAL_OCTUBRE_2021.pdf"
          },

          {
            label: "Noviembre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_MENSUAL_NOVIEMBRE_2021.pdf"
          },
          {
            label: "Diciembre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_MENSUAL_DICIEMBRE_2021.pdf"
          }
        ]
      },
       {
        label: "Conciliaciones Trimestrales con la Secretaría de Hacienda",
        subitems: [
          {
            label: "1er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION%201ER%20TRIMESTRE%205M%20FEDERAL.pdff"
          },
          {
            label: "2do. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/2DO_TRIMESTRE_CONCILIACION_2021.pdf"
          },
          {
            label: "3er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/3ER_TRIMESTRE_CONCILIACION_2021.pdf"
          },
          {
            label: "4to. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/4TO_TRIMESTRE_CONCILIACION_2021.pdf"
          },
        
          
        ]
      },
        {
        label: "1 al Millar",
        subitems: [
          {
            label: "1er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_1ER_TRIMESTRE_1ALMILLAR_2021.pdf"
          },
          {
            label: "2do. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/2DO_TRIMESTRE_1_AL_MILLAR.pdf"
          },
          {
            label: "3er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/3ER_TRIMESTRE_1_AL_MILLAR_2021.pdf"
          },
          {
            label: "4to. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_1ALMILLAR_4TO_TRIMESTRE_2021.pdf"
          },
          {
            label: "INFORME ANUAL 1 AL MILLAR 2025",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_CIERRE_1ALMILLAR_2021.pdf"
          },
          
        ]
      },
      
     
    ]
  },
  {
    id:6,
    color: '#a98188',
    title: "Ejercicio fiscal 2020.",
     items: [
        {
        label: "Programación de Presupuesto Anual  5 al Millar",
        subitems: [
          {
            label: "Programación de Presupuesto Anual  5 al Millar",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/PRESUPUESTO_5ALMILLAR_2021.pdf"
          },
         
        ]
        },

        {
        label: "Informes Mensuales",
              
        
        subitems: [
          {
            label: "Enero",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_INGRESOS_EGRESOS_MENSUAL_ENERO_2021.pdf"
          },
          {
            label: "Febrero",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_INGRESOS_EGRESOS_5_AL_MILLAR_FEBRERO_2021.pdf"
          },
          {
            label: "Marzo",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_INGRESOS_EGRESOS_5_AL_MILLAR_MARZO_2021.pdf"
          },
          {
            label: "Abril",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_ABRIL_5ALMILLAR_2022.pdf"
          },
          {
            label: "Mayo",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_EGRESOS_INGRESOS_MAYO_2021.pdf"
          },
          {
            label: "Junio",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_JUNIO_2021.pdf"
          },
          {
            label: "Julio",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_JULIO_2021.pdf"
          },
          {
            label: "Agosto",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_AGOSTO_2021.pdf"
          },
          {
            label: "Septiembre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_SEPTIEMBRE_2021.pdf"
          },
          {
            label: "Octubre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_OCTUBRE_2021.pdf"
          },

          {
            label: "Noviembre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_NOVIEMBRE_2021.pdf"
          },
          {
            label: "Diciembre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_DICIEMBRE_2021.pdf"
          },
          {
            label: "Informe Cierre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_CIERRE_5ALMILLAR_2021.pdf"
          }
        ]
      },
       {
        label: "Informes Acumulados",
        subitems: [
          // {
          //   label: "Enero",
          //   url: "/micro/principio1/codigo_etica_2025.pdf"
          // },
          {
            label: "Febrero",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ACUMULADO_INGRESOS_EGRESOS_5_AL_MILLAR_FEBRERO_2021.pdf"
          },
          {
            label: "Marzo",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ACUMULADO_INGRESOS_EGRESOS_5_AL_MILLAR_MARZO_2021.pdf"
          },
          {
            label: "Abril",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_ACUMULADO_5ALMILLAR_ABRIL_2021.pdf"
          },
          {
            label: "Mayo",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ACUMULADO_EGRESOS_INGRESOS_MAYO_2021.pdf"
          },
          {
            label: "Junio",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ACUMULADO_INGRESOS_EGRESOS_A_JUNIO_2020_5M.pdf"
          },
          {
            label: "Julio",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ACUMULADO_MES_DE_JULIO_2021.pdf"
          },
          {
            label: "Agosto",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ACUMULADO_AGOSTO_2021.pdff"
          },
          {
            label: "Septiembre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ACUMULADO_SEPTIEMBRE_2021.pdf"
          },
          {
            label: "Octubre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ACUMULADO_OCTUBRE_2021.pdf"
          },

          {
            label: "Noviembre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ACUMULADO_NOVIEMBRE_2021.pdff"
          },
          {
            label: "Diciembre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ACUMULADO_DICIEMBRE_2021.pdf"
          }
        ]
      },
      
      {
        label: "Conciliaciones mensuales con la Secretaría de Hacienda",
        subitems: [
          {
            label: "Enero",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_FINANZAS_ENERO_2021.pdf"
          },
          {
            label: "Febrero",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_FINANZAS_FEBRERO_2021.pdf"
          },
          {
            label: "Marzo",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION%205M%20FEDERAL%20MARZO.pdff"
          },
          {
            label: "Abril",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_5M_FEDERAL_ABRIL_2021.pdf"
          },
          {
            label: "Mayo",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_MAYO_5ALMILLAR_FEDERAL_2021.pdf"
          },
          {
            label: "Junio",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_MENSUAL_JUNIO_2021.pdf"
          },
          {
            label: "Julio",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_CONTABILIDAD_MES_DE_JULIO_2021.pdf"
          },
          {
            label: "Agosto",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_MENSUAL_AGOSTO_2021.pdf"
          },
          {
            label: "Septiembre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_MENSUAL_SEPTIEMBRE_2021.pdf"
          },
          {
            label: "Octubre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_MENSUAL_OCTUBRE_2021.pdf"
          },

          {
            label: "Noviembre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_MENSUAL_NOVIEMBRE_2021.pdf"
          },
          {
            label: "Diciembre",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION_MENSUAL_DICIEMBRE_2021.pdf"
          }
        ]
      },
       {
        label: "Conciliaciones Trimestrales con la Secretaría de Hacienda",
        subitems: [
          {
            label: "1er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/CONCILIACION%201ER%20TRIMESTRE%205M%20FEDERAL.pdff"
          },
          {
            label: "2do. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/2DO_TRIMESTRE_CONCILIACION_2021.pdf"
          },
          {
            label: "3er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/3ER_TRIMESTRE_CONCILIACION_2021.pdf"
          },
          {
            label: "4to. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/4TO_TRIMESTRE_CONCILIACION_2021.pdf"
          },
        
          
        ]
      },
       {
        label: "1 al Millar",
        subitems: [
          {
            label: "1er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_1ER_TRIMESTRE_1ALMILLAR_2021.pdf"
          },
          {
            label: "2do. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/2DO_TRIMESTRE_1_AL_MILLAR.pdf"
          },
          {
            label: "3er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/3ER_TRIMESTRE_1_AL_MILLAR_2021.pdf"
          },
          {
            label: "4to. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_1ALMILLAR_4TO_TRIMESTRE_2021.pdf"
          },
          {
            label: "INFORME ANUAL 1 AL MILLAR 2025",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_CIERRE_1ALMILLAR_2021.pdf"
          },
          
        ]
      },
      
     
    ]
  },
  // {
  //   id:7,
  //   color: '#a98188',
  //   title: "Ejercicio fiscal 2019",
  //    items: [

  //      {
  //       label: "Informes Mensuales",
        
        
  //       subitems: [
  //         {
  //           label: "Enero",
  //           url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_MENSUAL_5ALMILLAR_ENERO_2019.pdf",
  //         },
  //         {
  //           label: "Febrero",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "Marzo",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "Abril",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "Mayo",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "Junio",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "Julio",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "Agosto",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "Septiembre",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "Octubre",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },

  //         {
  //           label: "Noviembre",
  //           url: "/micro/principio1/codigo_etica_2026.pdf"
  //         },
  //         {
  //           label: "Diciembre",
  //           url: "/micro/principio1/anexos_codigo_etica.pdf"
  //         }
  //       ]
  //     },
  //      {
  //       label: "INFORME CIERRE ANUAL 2025 ''Informes Acumulados''",
  //       subitems: [
  //         {
  //           label: "Enero",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "Febrero",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "Marzo",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "Abril",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "Mayo",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "Junio",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "Julio",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "Agosto",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "Septiembre",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "Octubre",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },

  //         {
  //           label: "Noviembre",
  //           url: "/micro/principio1/codigo_etica_2026.pdf"
  //         },
  //         {
  //           label: "Diciembre",
  //           url: "/micro/principio1/anexos_codigo_etica.pdf"
  //         }
  //       ]
  //     },
  //      {
  //       label: "1 al Millar",
  //       subitems: [
  //         {
  //           label: "1er. Informe Trimestral",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "2do. Informe Trimestral",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "3er. Informe Trimestral",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "4to. Informe Trimestral",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "INFORME ANUAL 1 AL MILLAR 2025",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
          
  //       ]
  //     },
  //     {
  //       label: "Conciliaciones con la Secretaría de Hacienda",
  //       subitems: [
  //         {
  //           label: "Enero",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "Febrero",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "Marzo",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "Abril",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "Mayo",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "Junio",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "Julio",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "Agosto",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "Septiembre",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "Octubre",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },

  //         {
  //           label: "Noviembre",
  //           url: "/micro/principio1/codigo_etica_2026.pdf"
  //         },
  //         {
  //           label: "Diciembre",
  //           url: "/micro/principio1/anexos_codigo_etica.pdf"
  //         }
  //       ]
  //     },
  //      {
  //       label: "Conciliaciones Trimestrales con la Secretaría de Hacienda",
  //       subitems: [
  //         {
  //           label: "1er. Informe Trimestral",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "2do. Informe Trimestral",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "3er. Informe Trimestral",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
  //         {
  //           label: "4to. Informe Trimestral",
  //           url: "/micro/principio1/codigo_etica_2025.pdf"
  //         },
        
          
  //       ]
  //     },
      
     
  //   ]
  // },

];

const ArmonizacionContable = () => {
  const [expandedId, setExpandedId] = useState(null);

  useEffect(() => { window.scrollTo(0, 0); }, []);

  const toggleAccordion = (id) => {
    setExpandedId(prev => (prev === id ? null : id));
  };

  return (
    <>
    

      <div className="container ci-nav pt-4">
        {/* Title pill */}
        <div className="row justify-content-center mb-4">
          <div className="col-12 col-md-5 d-flex justify-content-center">
            <div className="ci-nav__btn--pill" style={{ cursor: 'default', margin: 0 }}>
              Recurso Federal 1 y 5 al Millar
            </div>
          </div>
        </div>

        {/* Text Description */}
        <div className="row justify-content-center mb-5">
          <div className="col-12 col-md-10">
            <p className="ci-desc-text">
             EJERCICIOS
            </p>
          </div>
        </div>

        {/* Accordion / Toggle List */}
        <div className="row justify-content-center">
          <div className="col-12 col-md-10">
            {principios.map((prin) => {


              const isExpanded = expandedId === prin.id;

              return (
                <div key={prin.id} className="mb-2">
                  {/* Header Button */}
                  <div 
                    className="ci-nav__btn ci-nav__btn--doc" 
                    onClick={() => toggleAccordion(prin.id)}
                    style={{ cursor: 'pointer', padding: '8px 12px' }}
                  >
                    <div className="ci-nav__icon" style={{ backgroundColor: prin.color }}>
                      <i className="fa-solid fa-id-card"></i>
                    </div>
                    <span className="ci-nav__label ci-nav__label--doc" style={{ fontSize: '1rem', color: '#621132' }}>
                      {prin.title}
                    </span>
                  </div>

                  {/* Expanded Content */}
                  <div className={`ci-accordion-wrapper ${isExpanded ? 'is-open' : ''}`}>
                    <div className="ci-accordion-inner">
                      {/* {prin.items.length > 0 ? (
                        <div className="ci-accordion-content ps-5 mt-1 mb-2">
                          <ul style={{ color: prin.color, fontSize: '0.95rem', fontStyle: 'italic', lineHeight: '1.6' }}>
                            {prin.items.map((item, idx) => (
                                <li key={idx} className="mb-2">
                                  <a 
                                    href={item.url || "#"}
                                    target={item.url ? "_blank" : "_self"}
                                    rel={item.url ? "noopener noreferrer" : ""}
                                    style={{ color: '#621132' }}
                                  >
                                    {item.label}
                                  </a>
                                </li>
                              ))}
                         </ul>
                        </div>
                      )  */}

                      {prin.items.map((item, idx) => (
                      <li key={idx} className="mb-2">
                        {item.subitems ? (
                          <>
                            <strong style={{ color: '#621132' }}>
                              {item.label}
                            </strong>

                            <ul style={{ marginTop: '5px', marginLeft: '20px' }}>
                              {item.subitems.map((subitem, subIdx) => (
                                <li key={subIdx}>
                                  <a
                                    href={subitem.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ color: '#9e2348' }}
                                  >
                                    {subitem.label}
                                  </a>
                                </li>
                              ))}
                            </ul>
                          </>
                        ) : (
                          <a
                            href={item.url || "#"}
                            target={item.url ? "_blank" : "_self"}
                            rel={item.url ? "noopener noreferrer" : ""}
                            style={{ color: '#621132' }}
                          >
                            {item.label}
                          </a>
                        )}
                      </li>
                    ))}
                    
                      { (
                        <div className="ci-accordion-content ps-5 mt-1 mb-2">
                          <p style={{ color: '#621132', fontSize: '0.95rem', fontStyle: 'italic' }}>
                            No hay documentos disponibles.
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default ArmonizacionContable;
